import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {InputHelpText} from '@/components/ui/input-help-text/InputHelpText'
import {InputStatusIcon} from '@/components/ui/input-status-icon/InputStatusIcon'
import {Label} from '@/components/ui/label/Label'
import {SelectList, SelectPopover, SelectTrigger} from '@/components/ui/select-atoms/SelectAtoms'
import {useTranslation} from '@/translations/i18n'
import {SelectProvider} from '@ariakit/react'
import {XCloseIcon} from '@/components/ui/icon/Icon'
import {Button} from '@/components/ui/button/Button'
import {
    StyledCareNeedsChip,
    StyledCareNeedsChipsContainer,
    StyledCareNeedsMultiSelectCheckbox,
    StyledCareNeedsMultiSelectCheckboxWrapper,
    StyledCareNeedsMultiSelectOption
} from './style'
import {ObjectEntries} from '@/utilities/helpers'
import {careNeedToLabel} from '@/features/projects/utils'
import {ProjectFieldsSchema} from '@/features/projects/formSchemas'
interface CareNeedsMultiSelectProps {
    errorMessage?: string
    values: ProjectFieldsSchema['careNeeds']
    onChange: (value: ProjectFieldsSchema['careNeeds'][number]) => void
}

export const CareNeedsMultiSelect = ({errorMessage, values, onChange}: CareNeedsMultiSelectProps) => {
    const {t} = useTranslation()

    return (
        <SelectProvider>
            <Flexbox direction="column" gap={1.5} fullWidth>
                <Label>{t('projects:care_needs')}</Label>
                <SelectTrigger
                    placeholder={t('commons:search_placeholder')}
                    fullWidth
                    value={values.map(value => value.name)}
                    hasError={!!errorMessage}
                    displayValue={() => undefined}
                />
                <Flexbox direction="column" gap={4} fullWidth>
                    {!!errorMessage && (
                        <Flexbox align="center" gap={1.5}>
                            <InputStatusIcon hasError={true} />
                            <InputHelpText error={errorMessage} />
                        </Flexbox>
                    )}
                    <StyledCareNeedsChipsContainer gap={2}>
                        {values.map(value => (
                            <StyledCareNeedsChip key={value.name} variant="neutral" shape="rectangle">
                                {t(careNeedToLabel[value.name])}
                                <Button variant="ghost" shape="text" onClick={() => onChange({name: value.name})}>
                                    <XCloseIcon />
                                </Button>
                            </StyledCareNeedsChip>
                        ))}
                    </StyledCareNeedsChipsContainer>
                </Flexbox>
                <SelectPopover>
                    <SelectList>
                        {ObjectEntries(careNeedToLabel).map(([key, label]) => (
                            <StyledCareNeedsMultiSelectOption key={key} gap={2} align="center" fullWidth>
                                <StyledCareNeedsMultiSelectCheckboxWrapper onClick={() => onChange({name: key})}>
                                    <StyledCareNeedsMultiSelectCheckbox
                                        id={key}
                                        checked={values.some(careNeed => careNeed.name == key)}
                                        onChange={() => onChange({name: key})}
                                    />
                                    {t(label)}
                                </StyledCareNeedsMultiSelectCheckboxWrapper>
                            </StyledCareNeedsMultiSelectOption>
                        ))}
                    </SelectList>
                </SelectPopover>
            </Flexbox>
        </SelectProvider>
    )
}
